import React from 'react';
import ToastContext from './ToastContext';

// A higher order component that will provide both layout and modal contexts to a passed component.
// The contexts will be available to the component through props
const withToast = WrappedComponent => props => (
	<ToastContext.Consumer>
		{({ showToast }) => <WrappedComponent {...props} showToast={showToast} />}
	</ToastContext.Consumer>
);

export default withToast;
